import React from "react";
import { Red } from "./sectionTbody/Red";
import { Explorer } from "./sectionTbody/Explorer";

export function Tbody(){
  return (
    <tbody>
      <tr className="container-table-body">
        <Red /><Explorer />
      </tr>
    </tbody>
  );
}
